export default __webpack_public_path__ + "3b5aa7f2e255111564f985823a135239.png";